<template>
	<FindingsMostSuggested v-if="isSearchMostSuggested" />
	<FindingsShop v-else />
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from "vue";
import useSearch from "@/SearchApp/composables/use-search";

const { isSearchMostSuggested } = useSearch();
const FindingsShop = defineAsyncComponent(() => import("./FindingsShop.vue"));
const FindingsMostSuggested = defineAsyncComponent(() => import("./FindingsMostSuggested.vue"));
</script>
